export default __webpack_public_path__ + "static/mx-bb7c71ea6bfd80c1cb796ac1fe9bf36e.svg";